import type { EventItem, NewsItem, ShopItem } from '../types';

export const demoShopItems: ShopItem[] = [
  { id: 'sample-outfit', name: 'Sample Outfit', type: 'outfit', price: 1500, tag: 'DEMO ITEM' },
  { id: 'sample-emote', name: 'Sample Emote', type: 'emote', price: 500, tag: 'DEMO ITEM' },
  { id: 'sample-bundle', name: 'Sample Bundle', type: 'bundle', price: 2000, tag: 'DEMO ITEM' },
  { id: 'sample-pickaxe', name: 'Sample Pickaxe', type: 'pickaxe', price: 800, tag: 'DEMO ITEM' },
  { id: 'sample-glider', name: 'Sample Glider', type: 'glider', price: 1200, tag: 'DEMO ITEM' }
];

export const demoNewsItems: NewsItem[] = [
  {
    id: 'official-feed',
    kind: 'official',
    title: 'Official Fortnite stories will appear here after source validation.',
    summary: 'NEXUS will keep the summary concise, clearly label the source, and link to the original story.',
    source: 'Fortnite News'
  },
  {
    id: 'competitive-feed',
    kind: 'competitive',
    title: 'Competitive announcements will have their own reading lane.',
    summary: 'Tournament and competitive updates will remain easy to distinguish from general game news.',
    source: 'Fortnite Competitive'
  },
  {
    id: 'nexus-original',
    kind: 'nexus',
    title: 'NEXUS Originals can sit beside trusted automated stories.',
    summary: 'Original editorial posts will be written and published from the private creator dashboard.',
    source: 'NEXUS Editorial'
  }
];

export const demoEvents: EventItem[] = [
  {
    id: 'events-source',
    title: 'Event source integration pending',
    status: 'planned',
    note: 'Real event times and countdowns will only appear after an approved source is connected and timezone handling is tested.'
  }
];

export const cosmeticTypes = ['all', 'outfit', 'emote', 'bundle', 'pickaxe', 'glider'] as const;
